<template>
  <nx-fullscreen-dialog
    :active="active"
    :title="title"
    @dismiss="dismiss"
    classes="nx-content-search"
    dismissable>
    <template slot="toolbar-items">
      <v-btn
        :disabled="!wizardValid"
        @click.native="$refs.wizard.create()"
        color="accent"
        flat dark
      >Crear
      </v-btn>
    </template>

    <v-container pb-3 fluid>
      <v-flex class="md8 offset-md2 sm10 offset-sm1 pt-4">
        <v-layout row wrap>
          <v-flex class="xs12 order-xs1 order-sm2">
            <nx-composition-module-wizard
              :editor-store-path="editorStorePath"
              :available-modules="availableModules"
              @form="wizardValid = $event.valid"
              ref="wizard"
              v-bind="$attrs"
              v-on="$listeners"
            ></nx-composition-module-wizard>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import NxCompositionModuleWizard from '@/modules/composition/components/module/CompositionModuleWizard';
import StorableEditorComponent from '@/mixins/storable-editor-component';

export default {
  mixins: [StorableEditorComponent],
  extends: NxFullscreenDialog,
  components: {
    NxCompositionModuleWizard,
    NxFullscreenDialog,
  },
  props: {
    availableModules: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      wizardValid: false,
    };
  },
};
</script>
